"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CarbonLedgerSigner = exports.CarbonNonSigner = exports.CarbonPrivateKeySigner = exports.isCarbonEIP712Signer = exports.CarbonSignerTypes = void 0;
const generic_1 = require("../util/generic");
const amino_1 = require("@cosmjs/amino");
const proto_signing_1 = require("@cosmjs/proto-signing");
var CarbonSignerTypes;
(function (CarbonSignerTypes) {
    CarbonSignerTypes[CarbonSignerTypes["Ledger"] = 0] = "Ledger";
    CarbonSignerTypes[CarbonSignerTypes["PrivateKey"] = 1] = "PrivateKey";
    CarbonSignerTypes[CarbonSignerTypes["BrowserInjected"] = 2] = "BrowserInjected";
    CarbonSignerTypes[CarbonSignerTypes["PublicKey"] = 3] = "PublicKey";
})(CarbonSignerTypes = exports.CarbonSignerTypes || (exports.CarbonSignerTypes = {}));
function isCarbonEIP712Signer(signer) {
    return signer.signLegacyEip712 !== undefined;
}
exports.isCarbonEIP712Signer = isCarbonEIP712Signer;
class CarbonPrivateKeySigner {
    constructor(privateKey, prefix) {
        this.privateKey = privateKey;
        this.prefix = prefix;
        this.type = CarbonSignerTypes.PrivateKey;
    }
    initWallet() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.wallet)
                this.wallet = yield proto_signing_1.DirectSecp256k1Wallet.fromKey(this.privateKey, this.prefix);
            return this.wallet;
        });
    }
    initAminoWallet() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.aminoWallet)
                this.aminoWallet = yield amino_1.Secp256k1Wallet.fromKey(this.privateKey, this.prefix);
            return this.aminoWallet;
        });
    }
    getAccounts() {
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = yield this.initWallet();
            return wallet.getAccounts();
        });
    }
    signAmino(signerAddress, signDoc) {
        return __awaiter(this, void 0, void 0, function* () {
            const aminoWallet = yield this.initAminoWallet();
            return yield aminoWallet.signAmino(signerAddress, signDoc);
        });
    }
    signDirect(signerAddress, signDoc) {
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = yield this.initWallet();
            return yield wallet.signDirect(signerAddress, signDoc);
        });
    }
    sendEvmTransaction(api, req) {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error("signing not available");
        });
    }
}
exports.CarbonPrivateKeySigner = CarbonPrivateKeySigner;
class CarbonNonSigner {
    constructor() {
        this.type = CarbonSignerTypes.PublicKey;
    }
    getAccounts() {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error("signing not available");
        });
    }
    signDirect() {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error("signing not available");
        });
    }
    sendEvmTransaction(api, req) {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error("signing not available");
        });
    }
}
exports.CarbonNonSigner = CarbonNonSigner;
// Uses amino because ledger does not work with protobuf yet
class CarbonLedgerSigner {
    constructor(ledger) {
        this.ledger = ledger;
        this.type = CarbonSignerTypes.Ledger;
    }
    retrieveAccount() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.account) {
                const address = yield this.ledger.getCosmosAddress();
                const pubkey = yield this.ledger.getPubKey();
                this.account = {
                    address,
                    algo: "secp256k1",
                    pubkey,
                };
            }
            return this.account;
        });
    }
    getAccounts() {
        return __awaiter(this, void 0, void 0, function* () {
            const account = yield this.retrieveAccount();
            return [account];
        });
    }
    signAmino(_, doc) {
        return __awaiter(this, void 0, void 0, function* () {
            const account = yield this.retrieveAccount();
            const { pubkey } = account;
            const msg = JSON.stringify(generic_1.sortObject(doc));
            const signBytes = yield this.ledger.sign(msg);
            const signature = amino_1.encodeSecp256k1Signature(pubkey, signBytes);
            return {
                signed: doc,
                signature,
            };
        });
    }
    sendEvmTransaction(api, req) {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error("signing not available");
        });
    }
}
exports.CarbonLedgerSigner = CarbonLedgerSigner;
